import { getMemberAccessToken } from '../auth/supabase';

export async function callGearHandoff(action, payload = {}) {
  const token = await getMemberAccessToken();
  if (!token) throw new Error('Member sign in required.');
  const response = await fetch('/api/gear-handoff', {
    method: 'POST',
    cache: 'no-store',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ action, ...payload }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body?.error || 'Unable to complete the gear handoff.');
    error.status = response.status;
    error.code = body?.code || '';
    throw error;
  }
  return body;
}

export function handoffTypeLabel(value) {
  return value === 'return_on_behalf' ? 'Return Gear for Me' : 'Take Over Gear';
}

export function activeReturnCustodySessions(sessions = []) {
  return (Array.isArray(sessions) ? sessions : []).filter(session =>
    session?.handoffType === 'return_on_behalf'
    && session?.status === 'accepted'
    && Array.isArray(session?.acceptedAssetIds)
    && session.acceptedAssetIds.some(id => !(session.returnedAssetIds || []).includes(id))
  );
}
